<template>
  <v-icon left
          :color="situacaoColor"
          v-on="$listeners"
          v-bind="$attrs">
    {{ icon }}
  </v-icon>
</template>

<script>
import { SituacaoEntregaCompra } from 'px-business-components';

export default {
  props: {
    situacao: String,
  },
  data() {
    return {
      mapIcon: {
        PENDENTE: 'mdi-truck-alert-outline',
        RECEBIDA: 'mdi-truck-check-outline',
      },
      mapColor: {
        PENDENTE: 'amber darken-1',
        RECEBIDA: 'success',
      },
    };
  },
  computed: {
    situacaoColor() {
      if (!this.situacao) {
        return '';
      }
      return this.mapColor[this.situacao];
    },
    icon() {
      if (!this.situacao) {
        return '';
      }
      return this.mapIcon[this.situacao];
    },
    text() {
      if (!this.situacao) {
        return '';
      }
      return SituacaoEntregaCompra.keys[this.situacao].description;
    },
  },
};
</script>
